import { render, staticRenderFns } from "./TemaMasivo.vue?vue&type=template&id=2a813470&"
import script from "./TemaMasivo.vue?vue&type=script&lang=js&"
export * from "./TemaMasivo.vue?vue&type=script&lang=js&"
import style0 from "./TemaMasivo.vue?vue&type=style&index=0&id=2a813470&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports